import {Box, Skeleton} from "@mui/material";
import Stack from "@mui/material/Stack";
import React from "react";
import {useTheme} from "@mui/material/styles";


export default function LazyLoadingPage() {
    const theme = useTheme();
    
    
    return (
        // Overall Box
        <Box sx={{display: 'flex', height: '100vh', backgroundColor: theme.palette.primary.background}}>
            
            {/* Side Navigation Component */}
            <Box sx={{height: '100vh', width: '220px', pl: 1, backgroundColor: theme.palette.primary.background}}>

                {/* For variant="text", adjust the height via font-size */}
                <Box sx={{display: 'flex', justifyContent: 'center'}}>
                    <Skeleton variant="text" width={180} sx={{fontSize: '3rem'}}/>
                </Box>
                {/* For other variants, adjust the size with `width` and `height` */}
                <Box
                    display="flex"
                    alignItems={"center"}
                    sx={{my: 2}}
                >
                    {/*Initials*/}
                    <Skeleton variant="rounded" width={40} height={40}/>
                    {/*Name*/}
                    <Skeleton variant="text" sx={{width: '120px', ml: 1, fontSize: '2rem'}}/>
                </Box>
                <Box>
                    <Stack spacing={1}>
                        <Skeleton variant="rounded" height={40}/>
                        <Skeleton variant="rounded" height={40}/>
                        <Skeleton variant="rounded" height={40}/>
                    </Stack>
                </Box>

                {/*Deposit Date Range*/}
                <Box width={220}>
                    <Stack spacing={1} sx={{mt: 1}}>
                        <Skeleton variant="text"
                                  sx={{width: '120px', ml: 1, fontSize: '2rem', alignSelf: 'center'}}/>
                        <Skeleton variant="rounded" height={60}/>
                        <Skeleton variant="rounded" height={60}/>
                    </Stack>
                </Box>

                {/*Update Check Data*/}
                <Box sx={{mt: 3}}>
                    <Skeleton variant="rounded" height={60}/>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        width: "220px",
                        flexDirection: "column",
                        position: "absolute",
                        bottom: 0,
                        alignSelf: "center",
                        alignItems: "center",
                        textAlign: "center",
                        pb: 1,
                    }}
                >
                    {/*DRP Version, Current Time, etc.*/}
                    <Skeleton variant="text" width={60}/>
                    <Skeleton variant="text" width={80}/>
                    <Skeleton variant="text" width={120}/>
                    <Skeleton variant="text" width={120}/>
                </Box>
            </Box>
            
            {/* Main Content Pages Component */}
            <Stack spacing={1} sx={{flexGrow: 1, padding: 1}}>
                <Box sx={{flexGrow: 1, height: '50vh'}}>
                    <Skeleton variant="rounded" sx={{height: '100%'}}/>
                </Box>
                <Box sx={{flexGrow: 1, height: '50vh'}}>
                    <Skeleton variant="rounded" sx={{height: '100%'}}/>
                </Box>
            </Stack>
        </Box>
    )
}